import { StaffAuthService } from "./../staff-auth.service";
import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
} from "@angular/common/http";
import { CustomerAuthService } from "app/login-phone/shared/services/auth.service";
import { environment } from "environments/environment";
import { AppConsts } from "app/shared/consts/app-consts";

const unAuthAPI = [`${environment.apiQuatangunilever}/ugift/AgeRange`];

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private auth: CustomerAuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Get the auth token from the service.
    const unileverCustomer = JSON.parse(
      localStorage.getItem(AppConsts.currentCustomerKey)
    );
    let fp = localStorage.getItem("_fp");
    let fpFull: any = localStorage.getItem("fpFull");
    if (fpFull) {
      fpFull = JSON.parse(fpFull);
    }
    if (!fp) {
      fp = "";
    }
    // const currentUserValue = this.auth.currentUserValue;
    if (unileverCustomer != null) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: unAuthAPI.includes(req.url)
            ? ""
            : `Bearer ${unileverCustomer.authToken}`,
          UID: unAuthAPI.includes(req.url) ? "" : unileverCustomer.uid,
          CampaignId: unAuthAPI.includes(req.url)
            ? ""
            : environment.requestHeader.CampaignId.toString(),
          MallId: unAuthAPI.includes(req.url)
            ? ""
            : environment.requestHeader.MallId &&
              environment.requestHeader.MallId
            ? environment.requestHeader.MallId.toString()
            : "0",
          StoreId: unAuthAPI.includes(req.url)
            ? ""
            : environment.requestHeader.StoreId &&
              environment.requestHeader.StoreId
            ? environment.requestHeader.StoreId.toString()
            : "0",
          fp: fp,
          rid: fpFull?.requestId || "",
        },
      });
      return next.handle(authReq);
    }
    const authReq = req.clone({
      setHeaders: {
        fp: fp,
        rid: fpFull?.requestId || "",
      },
    });
    // send cloned request with header to the next handler.
    return next.handle(authReq);
  }
}
